module.exports = __webpack_public_path__ + "static/img/third2_2_6_active.c9e70686.jpg";